import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/imgs/map-zh.png'
import _imports_1 from '../../assets/imgs/map-en.png'
import _imports_2 from '../../assets/imgs/car-move.png'
import _imports_3 from '../../assets/imgs/toolbox.png'
import _imports_4 from '../../assets/imgs/logo.png'
import _imports_5 from '../../assets/imgs/footer-text.png'
import _imports_6 from '../../assets/imgs/bilibili.png'
import _imports_7 from '../../assets/imgs/youtube.png'
import _imports_8 from '../../assets/imgs/linkedin.png'
import _imports_9 from '../../assets/imgs/csdn.png'
import _imports_10 from '../../assets/imgs/zhihu.png'
import _imports_11 from '../../assets/imgs/phone.png'
import _imports_12 from '../../assets/imgs/OfficialAccounts.png'
import _imports_13 from '../../assets/imgs/WeChatChannel.png'
import _imports_14 from '../../assets/imgs/beian.png'


const _withScopeId = n => (_pushScopeId("data-v-1076e30a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "footer" }
const _hoisted_2 = { class: "bg" }
const _hoisted_3 = {
  class: "footer__header",
  id: "footer"
}
const _hoisted_4 = { class: "header-left" }
const _hoisted_5 = { class: "footer__contact" }
const _hoisted_6 = { class: "horizontal-menu" }
const _hoisted_7 = { class: "menu-item" }
const _hoisted_8 = {
  target: "_blank",
  href: "https://ms.ytdevops.com"
}
const _hoisted_9 = {
  target: "_blank",
  href: "https://ms.ytdevops.com/pubKnowledge/8954eeec-f496-4f2d-84d3-ce62266d5ff7"
}
const _hoisted_10 = {
  target: "_blank",
  href: "https://ms.ytdevops.com/pubKnowledge/85b934dc-d50c-4d73-9f48-9d89dd07c439"
}
const _hoisted_11 = { class: "menu-item" }
const _hoisted_12 = {
  target: "_blank",
  href: "https://m-crecruit.liepin.com/job/share/detail-wx?sk=4b07155e0b88f6c7328f2765f6a4e7db&open_id=oKRge087a9jBkokZyB6rNI9b8_c8&nickname=%E5%BE%AE%E4%BF%A1%E7%94%A8%E6%88%B7&province=&sex=0&city=&country=&headimgurl=https://thirdwx.qlogo.cn/mmopen/vi_32/Q3auHgzwzM4wqqjLlPZib2zYNeiaAsSugD0NnaiamMIUFtpyyEQUps97RMZJyTCYwXY99Wu81OfR1sNOQfduZkucw/132&nonce=47083&timestamp=1661761198218&signature=4cf08d98eae30c9de710c1f52c68493633849456"
}
const _hoisted_13 = {
  target: "_blank",
  href: "https://tools.ytdevops.com/"
}
const _hoisted_14 = { class: "menu-item" }
const _hoisted_15 = { class: "menu-item" }
const _hoisted_16 = { style: {"font-size":"17px","margin-bottom":"1rem"} }
const _hoisted_17 = { style: {"color":"rgb(155, 156, 157)"} }
const _hoisted_18 = { style: {"font-size":"17px"} }
const _hoisted_19 = { style: {"color":"rgb(155, 156, 157)"} }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"color":"#999"} }, "support@ytdevops.com", -1))
const _hoisted_21 = { class: "menu-item" }
const _hoisted_22 = {
  key: 0,
  src: _imports_0,
  alt: ""
}
const _hoisted_23 = {
  key: 1,
  src: _imports_1,
  alt: ""
}
const _hoisted_24 = { class: "footer__main" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: ""
}, null, -1))
const _hoisted_26 = [
  _hoisted_25
]
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  alt: ""
}, null, -1))
const _hoisted_28 = [
  _hoisted_27
]
const _hoisted_29 = { class: "container" }
const _hoisted_30 = /*#__PURE__*/_createStaticVNode("<div class=\"leftContent\" data-v-1076e30a><div class=\"logo-box\" data-v-1076e30a><img src=\"" + _imports_4 + "\" alt=\"\" data-v-1076e30a></div><img style=\"width:320px;height:45px;margin-top:8rem;\" src=\"" + _imports_5 + "\" alt=\"\" data-v-1076e30a></div><div class=\"vertical-line\" data-v-1076e30a></div>", 2)
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "phoneBox" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_11,
    alt: ""
  }),
  /*#__PURE__*/_createElementVNode("p", null, "+86 138 1743 8496")
], -1))
const _hoisted_33 = { class: "wechatBox" }
const _hoisted_34 = { class: "wechatImg" }
const _hoisted_35 = { class: "wechatImg-box" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_12,
  alt: ""
}, null, -1))
const _hoisted_37 = {
  class: "wechatImg-box",
  style: {"margin-left":"4rem"}
}
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_13,
  alt: ""
}, null, -1))
const _hoisted_39 = { class: "bottom" }
const _hoisted_40 = { class: "bottom-list" }
const _hoisted_41 = {
  href: "https://beian.miit.gov.cn/#/Integrated/index",
  target: "_blank"
}
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_14,
  alt: ""
}, null, -1))
const _hoisted_43 = {
  href: "http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=32050702011070",
  target: "_blank"
}

import useLocale from "@/hooks/useLocale"; // 国际化hook
import { computed } from "@vue/reactivity";
import { useStore } from "vuex";
import { ref } from "vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'TheFooter',
  setup(__props) {

const store = useStore();
const lang = computed(() => store.getters.lang);
const {
  i18n: { t }, // 解构实例用具t 访问语言变量
} = useLocale();
// 映射显示名称到实际文件名
const imageMap = {
  displayName: "licence.png",
};

const openImage = () => {
  const actualFileName = imageMap["displayName"];
  const imageUrl = `/img/${actualFileName}`;
  window.open(imageUrl, "_blank");
};

function goToBSite() {
  window.open(
    "https://space.bilibili.com/520603057?spm_id_from=333.1007.0.0",
    "_blank"
  );
}

function goToYT() {
  window.open("https://www.youtube.com/@YunTi-Devops", "_blank");
}

function goToLK() {
  window.open("https://www.linkedin.com/company/yuntitech", "_blank");
}
function goTocsdn() {
  window.open("https://blog.csdn.net/yuchao_luo?type=blog", "_blank");
}
function goTozhihu() {
  window.open("https://www.zhihu.com/people/yuchao-luo-59", "_blank");
}

function toTop() {
  // const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
  // // 这里如果写大于0，会出现不可下滑的bug
  // if (scrollTop > 1) {
  //   window.requestAnimationFrame(toTop);
  //   window.scrollTo(0, scrollTop - scrollTop / 8);
  // }
  window.scrollTo({
    top: 0,
    behavior: "smooth",
  });
}
function toTool() {
  window.open(
    "https://tools.ytdevops.com/?lang=" +
      (window.localStorage.getItem("lang")
        ? window.localStorage.getItem("lang")
        : "zh")
  );
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h3", null, _toDisplayString(_unref(t)("footer.header.title")), 1),
          _createElementVNode("p", null, _toDisplayString(_unref(t)("footer.header.desc")), 1)
        ]),
        _createElementVNode("a", {
          class: _normalizeClass(["btn-right", { padding__en: _unref(lang) === 'en' }]),
          target: "_blank",
          href: "https://m-crecruit.liepin.com/job/share/detail-wx?sk=4b07155e0b88f6c7328f2765f6a4e7db&open_id=oKRge087a9jBkokZyB6rNI9b8_c8&nickname=%E5%BE%AE%E4%BF%A1%E7%94%A8%E6%88%B7&province=&sex=0&city=&country=&headimgurl=https://thirdwx.qlogo.cn/mmopen/vi_32/Q3auHgzwzM4wqqjLlPZib2zYNeiaAsSugD0NnaiamMIUFtpyyEQUps97RMZJyTCYwXY99Wu81OfR1sNOQfduZkucw/132&nonce=47083&timestamp=1661761198218&signature=4cf08d98eae30c9de710c1f52c68493633849456"
        }, _toDisplayString(_unref(t)("footer.header.button")), 3)
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("ul", _hoisted_6, [
        _createElementVNode("li", _hoisted_7, [
          _createElementVNode("h3", null, _toDisplayString(_unref(t)("footer.contact.product")), 1),
          _createElementVNode("a", _hoisted_8, _toDisplayString(_unref(t)("footer.contact.free")), 1),
          _createVNode(_component_router_link, {
            target: "_blank",
            to: "/price"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)("footer.contact.longTerm")), 1)
            ]),
            _: 1
          }),
          _createElementVNode("a", _hoisted_9, _toDisplayString(_unref(t)("footer.contact.termsOfUse")), 1),
          _createElementVNode("a", _hoisted_10, _toDisplayString(_unref(t)("footer.contact.privacyPolicy")), 1)
        ]),
        _createElementVNode("li", _hoisted_11, [
          _createElementVNode("h3", null, _toDisplayString(_unref(t)("footer.contact.company")), 1),
          _createVNode(_component_router_link, {
            target: "_blank",
            to: "/about-us"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)("footer.contact.aboutUs")), 1)
            ]),
            _: 1
          }),
          _createElementVNode("a", _hoisted_12, _toDisplayString(_unref(t)("footer.contact.joinUs")), 1),
          _createElementVNode("a", _hoisted_13, _toDisplayString(_unref(t)("footer.contact.ITtool")), 1)
        ]),
        _createElementVNode("li", _hoisted_14, [
          _createElementVNode("h3", null, _toDisplayString(_unref(t)("footer.contact.address")), 1),
          _createElementVNode("p", {
            class: _normalizeClass({ font__en: _unref(lang) === 'en' }),
            style: {"color":"#999"}
          }, _toDisplayString(_unref(t)("footer.contact.addLine1")), 3),
          _createElementVNode("p", {
            class: _normalizeClass({ font__en: _unref(lang) === 'en' }),
            style: {"color":"#999"}
          }, _toDisplayString(_unref(t)("footer.contact.addLine2")), 3)
        ]),
        _createElementVNode("li", _hoisted_15, [
          _createElementVNode("h3", null, _toDisplayString(_unref(t)("footer.contact.service")), 1),
          _createElementVNode("h2", _hoisted_16, [
            _createElementVNode("span", _hoisted_17, _toDisplayString(_unref(t)("footer.contact.china")), 1),
            _createTextVNode(" +86 138 1743 8496 ")
          ]),
          _createElementVNode("h2", _hoisted_18, [
            _createElementVNode("span", _hoisted_19, _toDisplayString(_unref(t)("footer.contact.overseas")), 1),
            _createTextVNode(" +65 8312 1028 ")
          ]),
          _hoisted_20
        ]),
        _createElementVNode("li", _hoisted_21, [
          (_unref(lang) === 'zh')
            ? (_openBlock(), _createElementBlock("img", _hoisted_22))
            : _createCommentVNode("", true),
          (_unref(lang) === 'en')
            ? (_openBlock(), _createElementBlock("img", _hoisted_23))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_24, [
      _createElementVNode("div", {
        class: "car-box",
        onClick: toTop
      }, _hoisted_26),
      _createElementVNode("div", {
        class: "tool-box",
        onClick: toTool
      }, _hoisted_28),
      _createElementVNode("div", _hoisted_29, [
        _hoisted_30,
        _createElementVNode("div", { class: "midContent" }, [
          _createElementVNode("div", { class: "imgOutsideBox" }, [
            _createElementVNode("img", {
              onClick: goToBSite,
              class: "outside",
              src: _imports_6,
              alt: ""
            }),
            _createElementVNode("img", {
              onClick: goToYT,
              class: "outside",
              src: _imports_7,
              alt: ""
            }),
            _createElementVNode("img", {
              onClick: goToLK,
              class: "outside",
              src: _imports_8,
              alt: ""
            }),
            _createElementVNode("img", {
              onClick: goTocsdn,
              class: "outside",
              src: _imports_9,
              alt: ""
            }),
            _createElementVNode("img", {
              onClick: goTozhihu,
              class: "outside",
              src: _imports_10,
              alt: ""
            })
          ]),
          _hoisted_32
        ]),
        _createElementVNode("div", _hoisted_33, [
          _createElementVNode("div", _hoisted_34, [
            _createElementVNode("div", _hoisted_35, [
              _hoisted_36,
              _createElementVNode("p", null, _toDisplayString(_unref(t)("footer.contact.OfficialAccounts")), 1)
            ]),
            _createElementVNode("div", _hoisted_37, [
              _hoisted_38,
              _createElementVNode("p", null, _toDisplayString(_unref(t)("footer.contact.WeChatChannel")), 1)
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_39, [
        _createElementVNode("ul", _hoisted_40, [
          _createElementVNode("li", null, _toDisplayString(_unref(t)("footer.main.right")), 1),
          _createElementVNode("li", null, _toDisplayString(_unref(t)("footer.main.company")), 1),
          _createElementVNode("li", null, [
            _createElementVNode("a", _hoisted_41, _toDisplayString(_unref(t)("footer.main.icp")), 1)
          ]),
          _createElementVNode("li", null, [
            _hoisted_42,
            _createElementVNode("a", _hoisted_43, _toDisplayString(_unref(t)("footer.main.record")), 1)
          ]),
          _createElementVNode("li", {
            style: {"cursor":"pointer"},
            onClick: openImage
          }, _toDisplayString(_unref(t)("footer.main.licence")), 1)
        ])
      ])
    ])
  ]))
}
}

})